import { BufferWriter, Writer } from "protobufjs";
import { ClientBookmark } from "../../../domain/model/client_bookmark";
import { IClientBookmarkRepository } from "../../../domain/repository/client_bookmark_repository";
import { IApiClient } from "../client";
import { common, entity } from "../rpc/api";
import { getToken } from "./bind_token";
import ClientBookmarkList = entity.ClientBookmarkList;
import CustomerID = entity.CustomerID;
import Empty = common.Empty;

import {
  ClientBookmarkConvertResponse,
  ClientBookmarkConvertResponseList,
} from "./client_bookmark_api_convert";

class ClientBookmarkAPI implements IClientBookmarkRepository {
  constructor(readonly apiClient: IApiClient) {}

  public getAllByClient(): Promise<ClientBookmark[]> {
    return new Promise<ClientBookmark[]>((resolve, reject) => {
      getToken()
        .then((token: string): Promise<Uint8Array> => {
          const req: Empty = new Empty();
          const writer: BufferWriter | Writer = Writer.create();
          return this.apiClient.postWithToken(
            "/api.ClientBookmarkService/GetAll",
            token,
            Empty.encode(req, writer).finish()
          );
        })
        .then((binary: Uint8Array): void => {
          const res: ClientBookmarkList = ClientBookmarkList.decode(binary);
          // BE=>FE 型変換
          const resConverted: ClientBookmarkConvertResponseList =
            ClientBookmarkConvertResponseList.from(res);
          const items: ClientBookmark[] = resConverted.items.map(
            (item: ClientBookmarkConvertResponse): ClientBookmark => {
              return ClientBookmark.from(item);
            }
          );
          resolve(items);
        })
        .catch((error: Error): void => {
          reject(error);
        });
    });
  }

  public create(customerID: string): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      getToken()
        .then((token: string): Promise<Uint8Array> => {
          const req: CustomerID = new CustomerID();
          req.id = customerID;
          const writer: BufferWriter | Writer = Writer.create();
          return this.apiClient.postWithToken(
            "/api.ClientBookmarkService/Create",
            token,
            CustomerID.encode(req, writer).finish()
          );
        })
        .then((binary: Uint8Array): void => {
          resolve();
        })
        .catch((error: Error): void => {
          reject(error);
        });
    });
  }

  public delete(customerID: string): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      getToken()
        .then((token: string): Promise<Uint8Array> => {
          const req: CustomerID = new CustomerID();
          req.id = customerID;
          const writer: BufferWriter | Writer = Writer.create();
          return this.apiClient.postWithToken(
            "/api.ClientBookmarkService/Delete",
            token,
            CustomerID.encode(req, writer).finish()
          );
        })
        .then((binary: Uint8Array): void => {
          resolve();
        })
        .catch((error: Error): void => {
          reject(error);
        });
    });
  }
}

const createClientBookmarkAPI = (
  apiClient: IApiClient
): IClientBookmarkRepository => {
  return new ClientBookmarkAPI(apiClient);
};

export { createClientBookmarkAPI };



// WEBPACK FOOTER //
// ./src/infra/api/service/client_bookmark_api.ts